import { ButtonDialog, Card, Spinner } from '@autopass-web/mochi-component';
import useStore from './store';
import styles from './index.module.scss';
import useAppStore from '../../app-store';
import Timer from './timer';
import { useEffect, useRef } from 'react';
import { analytics } from '../../app-loader';
import dayjs from 'dayjs';

const ScanCodeCard = () => {
  const appStore = useAppStore();
  const store = useStore();
  const timerRef = useRef();

  useEffect(() => {
    if (store.barcodeCountdown) {
      timerRef.current?.onPauseCountDown();
    }
  }, [store.barcodeCountdown]);

  if (store.loading)
    return (
      <Card className={styles['loading-card']}>
        <Spinner />
      </Card>
    );

  return (
    <>
      <ButtonDialog
        title="條碼已過期"
        message="您的交易條碼已過期，請點擊「更新條碼」重試。"
        buttonList={[
          {
            theme: 'positive',
            content: '更新條碼',
            onClick: () => {
              analytics.barcode_payment_dialog_onClick({
                type: 'times_up',
                action: '更新條碼',
              });
              timerRef.current.onRestartCountDown();
              store.fetchBarcodePaymentData();
              store.setBarcodePaymentDialog(null);
            },
          },
          {
            theme: 'cancel',
            content: '關閉',
            onClick: () => {
              analytics.barcode_payment_dialog_onClick({
                type: 'times_up',
                action: '關閉',
              });
              appStore.globalAction.backToMain();
              store.setBarcodePaymentDialog(null);
            },
          },
        ]}
        show={store.barcodePaymentDialog?.type === 'times_up'}
      />
      <Card className={styles['barcode-payment-card']}>
        {!appStore.defaultReceipt && <PaymentCard />}
        <div className={styles.code}>
          <div className={styles.barcode}>
            <img src={store.barcodeUrl} />
            <span>{store.token}</span>
          </div>
          <div className={styles.qrcode}>
            <img src={store.qrcodeUrl} />
          </div>
          <div className={styles.countdown}>
            <Timer
              ref={timerRef}
              countDownSeconds={dayjs(store.expiredAt).diff(dayjs(), 's')}
              onRefresh={() => {
                analytics.barcode_payment_refresh_onClick();
                store.fetchBarcodePaymentData();
              }}
              onTimesUp={() =>
                store.setBarcodePaymentDialog({ type: 'times_up' })
              }
            />
          </div>
        </div>
      </Card>
    </>
  );
};

const PaymentCard = () => {
  const appStore = useAppStore();
  const creditCard = appStore.user.currentCreditCard;

  const cardTypeImage = (type) => {
    switch (type) {
      case 'master':
        return '/assets/card_mastercard.svg';
      case 'jcb':
        return '/assets/card_jcb.svg';
      default:
        return '/assets/card_visa.svg';
    }
  };

  return (
    <div className={styles.card}>
      <div className={styles['card-logo']}>
        <img src={cardTypeImage(creditCard.cardType)} alt="arrow icon" />
      </div>
      <span className={styles['card-name']}>
        {creditCard.bank?.shortName || ''}
      </span>
      <span>····</span>&nbsp;
      {creditCard.lastFourCode}
    </div>
  );
};

export default ScanCodeCard;
